import account from './account';
import auth from './auth';
import colours from './colours';
import dashboards from './dashboards';
import filters from './filters';
import integrations from './integrations';
import kpis from './kpis';
import monitors from './monitors';
import persistence from './persistence'; // eslint-disable-line import/no-cycle
import role from './role';
import settings from './settings';
import ui from './ui';
import users from './users';
import view from './view';
import widgets from './widgets';

export default {
  account,
  auth,
  colours,
  role,
  ui,
  widgets,
  dashboards,
  monitors,
  filters,
  users,
  persistence,
  integrations,
  settings,
  view,
  kpis,
};
